import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const isServerSide = typeof window === 'undefined';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
            staleTime: 10 * 1000,
            retryOnMount: !isServerSide,
        },
    },
});

export const UseQueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
